const num = (v) => {
  const f = Number(v);
  return Number.isFinite(f) && f > 0 ? f : null;
};

export function computeMetrics(weight, heightCm, waistCm) {
  const w = num(weight), h = num(heightCm), wc = num(waistCm);
  return {
    bmi: w && h ? Math.round((w / (h / 100) ** 2) * 10) / 10 : null,
    whtr: wc && h ? Math.round((wc / h) * 100) / 100 : null,
  };
}

export function metricsFromResponses(responses) {
  const v = (k) => responses?.[k]?.value;
  return computeMetrics(v("vitals_weight_kg"), v("vitals_height_cm"), v("vitals_waist_cm"));
}

const TONES = {
  green: "bg-emerald-50 text-emerald-800 border-emerald-300",
  amber: "bg-amber-50 text-amber-900 border-amber-300",
  red: "bg-rose-50 text-rose-800 border-rose-300",
  sky: "bg-sky-50 text-sky-800 border-sky-300",
};

export function bmiCategory(v) {
  if (v == null) return null;
  if (v < 18.5) return { label: "Underweight", tone: TONES.sky };
  if (v < 25) return { label: "Healthy", tone: TONES.green };
  if (v < 30) return { label: "Overweight", tone: TONES.amber };
  return { label: "Obese", tone: TONES.red };
}

export function whtrCategory(v) {
  if (v == null) return null;
  if (v < 0.5) return { label: "Healthy", tone: TONES.green };
  if (v < 0.6) return { label: "Increased risk", tone: TONES.amber };
  return { label: "High risk", tone: TONES.red };
}
